/* istanbul ignore file */
import { useMemo } from 'react';
import type { RefCallback, MutableRefObject, Ref } from 'react';

type TRFCB<T> = T extends RefCallback<infer R> ? RefCallback<R> : RefCallback<T>;

export function setRef<T>(
    ref: MutableRefObject<T | null> | ((instance: T | null) => void) | null | undefined,
    value: T | null
): void {
    if (typeof ref === 'function') {
        ref(value);
    } else if (ref) {
        ref.current = value;
    }
}

export function useForkRef<T>(
    refA: Ref<T> | null | undefined,
    refB: Ref<T> | null | undefined
): TRFCB<T | null> | null {
    return useMemo(() => {
        if (refA == null && refB == null) {
            return null;
        }

        return (refValue: T | null) => {
            setRef(refA, refValue);
            setRef(refB, refValue);
        };
    }, [refA, refB]);
}
